import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarFiveSides = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	viewBox: "0 0 13.6505 13.125",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5003 13.125L6.82525 10.2812L3.15018 13.125L2.2713 12.4794L3.74621 8.05L0 5.41228L0.335707 4.375H4.9223L6.28207 0H7.36844L8.72821 4.375H13.3148L13.6505 5.41228L9.9043 8.05L11.3792 12.4794L10.5003 13.125Z",
		fill: "#F5B800"
	})
});
export default SvgStarFiveSides;
